var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Vue, Watch } from 'vue-property-decorator';
import { Year as YearModel } from '@/models/Year';
import PageHeader from '@/components/page-header/PageHeader';
import DataTable from '@/components/data-table/DataTable';
import Periods from '@/views/Periods/Periods';
import { Period } from '@/models/Period';
import ErrorHandler from '@/support/ErrorHandler';
let Year = class Year extends Vue {
    constructor() {
        super(...arguments);
        this.$pageTitle = 'Year';
        this.year = new YearModel();
        this.originalYear = new YearModel();
        this.isEditing = false;
        this.isEditingStartDate = false;
        this.isEditingEndDate = false;
        this.isEditingGeneratedStartDate = false;
        this.isEditingGeneratedEndDate = false;
    }
    get breadcrumbs() {
        return [{ name: this.$tc('year.title', 2), path: '/years' }, { name: this.year.name || 'Year', path: this.$route.path }];
    }
    get tableOptions() {
        return {
            name: {
                singular: 'Period',
                plural: 'Periods',
            },
            headers: [
                {
                    text: this.$t('name.title'),
                    value: 'name',
                },
                { text: this.$t('value.title'), value: 'value' },
                { text: this.$t('starts.title'), value: 'starts_at' },
                { text: this.$t('ends.title'), value: 'ends_at' },
            ],
            actions: [],
            filters: [],
            dropdown: [],
            model: new Period().filter('years', [this.year.id]),
        };
    }
    mounted() {
        this.fetchYears();
    }
    update() {
        this.isEditing = false;
        this.year.update().then((year) => {
            this.year = year;
            this.originalYear = this.year;
        });
    }
    handlePeriodEdit(table, period) {
        table.refresh();
    }
    handlePeriodDelete(table, period) {
        table.refresh();
    }
    yearChanged(year, oldYear) {
        this.$pageTitle = this.year.name || 'Year';
    }
    fetchYears() {
        this.year
            .find(this.$route.params.id)
            .then((year) => {
            this.year = year;
            this.originalYear = this.year;
            this.year.lvs_generate_m_test_at = '2021-02-02';
            this.year.lvs_generate_e_test_at = '2021-03-02';
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
};
__decorate([
    Watch('year'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Year, Year]),
    __metadata("design:returntype", void 0)
], Year.prototype, "yearChanged", null);
Year = __decorate([
    Component({
        components: {
            DataTable,
            PageHeader,
            Periods,
        },
    })
], Year);
export default Year;
